const FOCUS_SOURCE_ATTRIBUTE = "data-focus-source";

export const trackKeyboardFocusSource = () => {
  window.addEventListener("pointerdown", markPointerFocus, true);
  window.addEventListener("keydown", markKeyboardFocus, true);
};

const markPointerFocus = () => {
  document.documentElement.setAttribute(FOCUS_SOURCE_ATTRIBUTE, "pointer");
};

const markKeyboardFocus = (event: KeyboardEvent) => {
  if (event.key !== "Tab") {
    return;
  }
  document.documentElement.setAttribute(FOCUS_SOURCE_ATTRIBUTE, "keyboard");
};
